// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CrsDetail
 */
export interface CrsDetail {
  /**
   *
   */
  code: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  url?: string | null;
}

/**
 * Check if a given object implements the CrsDetail interface.
 */
export function instanceOfCrsDetail(value: object): value is CrsDetail {
  if (!("code" in value) || value["code"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function CrsDetailFromJSON(json: any): CrsDetail {
  return CrsDetailFromJSONTyped(json, false);
}

export function CrsDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrsDetail {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    name: json["name"],
    url: json["url"] === undefined ? undefined : json["url"] === null ? null : json["url"],
  };
}

export function CrsDetailToJSON(json: any): CrsDetail {
  return CrsDetailToJSONTyped(json, false);
}

export function CrsDetailToJSONTyped(
  value?: CrsDetail | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    code: value["code"],
    name: value["name"],
    url: value["url"],
  };
}
